import { createNavigation } from 'next-intl/navigation'

import { DesktopLink } from './desktop-link'
import { routing } from './routing'

// Locale-aware navigation helpers. `redirect`/`getPathname` automatically
// add the locale prefix for non-default locales (`localePrefix: 'as-needed'`),
// so components link with bare paths like `/` and `/thank-you`.
// `Link` is the dual-host adapter so Studio can prefix `/desktop`.
export const { redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
export const Link = DesktopLink
